<template>
  <div class="assignment-overall">
    <el-row>
      <el-col :span="12">
        <div class="assignment-overall__left">
          <span class="assignment-overall__score-heading text-bold">{{ $t('assignments.details.overall_result_overall_score') }}</span>
          <div class="assignment-score">
            <span class="assignment-score__label">{{ $t('assignments.details.overall_result_max_score') }}</span>
            <span class="assignment-score__value text-bold">{{ overall.maxScore }}%</span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">{{ $t('assignments.details.overall_result_average_score') }}</span>
            <span class="assignment-score__value text-bold">{{ overall.averageScore }}%</span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">{{ $t('assignments.details.overall_result_min_score') }}</span>
            <span class="assignment-score__value text-bold">{{ overall.minScore }}%</span>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="assignment-overall__right">
          <div class="assignment-score">
            <span class="assignment-score__label assignment-score__label--text-black">{{ $t('assignments.details.overall_result_submissions') }}</span>
            <span class="assignment-score__value text-bold">{{ totalValidSubmitted }} {{ $t('assignments.details.overall_result_submissions_out_of') }} {{ overall.totalStudents }}</span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">{{ $t('assignments.details.overall_result_submission_on_time') }}</span>
            <span class="assignment-score__value text-bold">
              <chip-rounded>{{ overall.totalSubmissionOntime }}</chip-rounded>
            </span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">{{ $t('assignments.details.overall_result_submission_late') }}</span>
            <span class="assignment-score__value text-bold">
              <chip-rounded class="chip-rounded--orange">{{ overall.totalSubmissionLate }}</chip-rounded>
            </span>
          </div>
          <div class="assignment-score">
            <span class="assignment-score__label">{{ $t('assignments.details.overall_result_submission_missed') }}</span>
            <span class="assignment-score__value text-bold">
              <chip-rounded class="chip-rounded--red">{{ overall.totalSubmissionMissed }}</chip-rounded>
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ChipRounded from '../common/ChipRounded.vue'
export default {
  components: {
    ChipRounded
  },
  props: {
    overall: {
      type: Object,
      default: () => ({
        maxScore: 0,
        averageScore: 0,
        minScore: 0,
        totalSubmissionOntime: 0,
        totalSubmissionLate: 0,
        totalSubmissionMissed: 0,
        totalStudents: 0
      })
    }
  },
  computed: {
    totalValidSubmitted() {
      return this.overall.totalSubmissionLate + this.overall.totalSubmissionOntime;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.assignment-overall {
  font-size: 16px;
  font-weight: 600;

  &__score-heading {
    margin-bottom: 20px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    padding-right: 80px;
  }

  &__right {
    padding-left: 24px;
    padding-right: 20px;
    border-left: 1px solid $gray-2;
  }

}
.assignment-score {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 15px;

  &:last-child {
    padding-bottom: 0;
  }

  &__label {
    color: $gray-1;
    line-height: 24px;
    width: 60%;
    &--text-black {
      color: $black;
    }
  }
  &__value {
    display: flex;
    justify-content: center;
    width: 40%;
    margin-left: auto;
  }
}
</style>